import { Route, Routes,Navigate } from 'react-router-dom';
import { ConfigurationPage, Ssrcodes,CurrencyMasterPage } from "./inner-components";
import { NotFoundError } from '../../components/Error_Page/NotFoundError';

export const ConfigMainPage = (props) => {
  return (
    <div className="flexRow full p-0 m-0">
      <div className='full-flex flexCol width100 p-0 m-0'>
        <Routes>
        <Route path="/" element={<Navigate replace to="configuration" />} />
          <Route path="/configuration" element={<ConfigurationPage />} />
          <Route path="/ssr" element={<Ssrcodes />} />
          <Route path="/currencyMaster" element={<CurrencyMasterPage />} />
          <Route path="*" element={<NotFoundError />} />                   
        </Routes>
      </div>
    </div>
  )
}
